/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import ReactPaginate from 'react-paginate';

const PaginationComponent = ({
  pageCount,
  onPageChange,
  currentPage,
  previousLabel = '上一页',
  nextLabel = '下一页',
  breakLabel = '...',
  marginPagesDisplayed = 2,
  pageRangeDisplayed = 5,
}) => {
  // 确保 pageCount 不小于 0
  const validPageCount = Math.max(0, pageCount);
  // 当有效页码总数为 0 时，不渲染分页组件
  if (validPageCount === 0) {
    return null;
  }
  // 计算安全的当前页码，确保不超过最大页码索引（validPageCount - 1），且不小于 0
  const safeCurrentPage = Math.min(
    Math.max(0, currentPage),
    validPageCount - 1
  );

  return (
    <div>
      <ReactPaginate.default
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        breakLabel={breakLabel}
        pageCount={validPageCount}
        marginPagesDisplayed={marginPagesDisplayed}
        pageRangeDisplayed={pageRangeDisplayed}
        onPageChange={onPageChange}
        forcePage={safeCurrentPage}
        containerClassName={'pagination justify-content-center'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        breakClassName={'page-item'}
        breakLinkClassName={'page-link'}
        activeClassName={'active'}
      />
    </div>
  );
};

export default PaginationComponent;
